module.exports = __webpack_public_path__ + "img/32.29f5e27a.png";